export const UserSettingService = Symbol.for('UserSettingService');
